module.exports = __webpack_public_path__ + "static/media/12_dominion-new_westminster.cafd4f3c.jpg";